import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { markdownComponents, flattenMarkdownChildren } from "../Markdown/markdownComponents";
import {
  ControlPlaneDiagram,
  ControlPlaneWithLLMDiagram,
  LLMDetailDiagram,
  SecurityDiagram,
  QueryAuditDiagram,
  UpdateAuditDiagram,
} from "../Diagrams/K8sDiagrams";

/** Maps visible heading text (from Markdown) to in-page anchor ids used by the sidebar TOC. */
export const HOME_K8S_HEADING_IDS = {
  "1. The Control Plane": "home-control-plane",
  "2. Observing the Control Plane": "home-observing-control-plane",
  "3. The LLM Component": "home-llm-component",
  "3.1 It is Secure": "home-llm-secure",
  "3.2 It is Auditable (Query)": "home-llm-audit-query",
  "3.3 It is Auditable (Update)": "home-llm-audit-update",
  "3.4 It is Your Own Runtime": "home-llm-runtime",
};

const HOME_K8S_DIAGRAM_COMPONENTS = {
  ControlPlaneDiagram,
  ControlPlaneWithLLMDiagram,
  LLMDetailDiagram,
  SecurityDiagram,
  QueryAuditDiagram,
  UpdateAuditDiagram,
};

function headingProps(Tag) {
  return function HomeHeading({ children, ...rest }) {
    const label = flattenMarkdownChildren(children).trim();
    const id = HOME_K8S_HEADING_IDS[label];
    return (
      <Tag id={id || undefined} {...rest}>
        {children}
      </Tag>
    );
  };
}

export const homeK8sArticleMarkdownComponents = {
  ...markdownComponents,
  h2: headingProps("h2"),
  h3: headingProps("h3"),
  h4: headingProps("h4"),
};

const DIAGRAM_LINE = /^<<<DIAGRAM:([A-Za-z0-9]+)>>>\s*$/gm;

/**
 * Splits `Text/Home/home-k8s-sections.md` into alternating markdown chunks and diagram placeholders.
 */
export function splitHomeK8sArticleMarkdown(source) {
  if (!source || !source.trim()) return [];
  const segments = [];
  let lastIndex = 0;
  let match;
  DIAGRAM_LINE.lastIndex = 0;
  while ((match = DIAGRAM_LINE.exec(source)) !== null) {
    const md = source.slice(lastIndex, match.index).trim();
    if (md) {
      segments.push({ type: "markdown", content: md });
    }
    segments.push({ type: "diagram", name: match[1] });
    lastIndex = DIAGRAM_LINE.lastIndex;
  }
  const tail = source.slice(lastIndex).trim();
  if (tail) {
    segments.push({ type: "markdown", content: tail });
  }
  return segments;
}

export function HomeK8sArticleBlocks({ markdownSource }) {
  const segments = splitHomeK8sArticleMarkdown(markdownSource);
  return segments.map((seg, i) => {
    if (seg.type === "markdown") {
      return (
        <ReactMarkdown
          key={`md-${i}`}
          remarkPlugins={[remarkGfm]}
          components={homeK8sArticleMarkdownComponents}
        >
          {seg.content}
        </ReactMarkdown>
      );
    }
    const Diagram = HOME_K8S_DIAGRAM_COMPONENTS[seg.name];
    if (!Diagram) {
      return null;
    }
    return <Diagram key={`diagram-${i}-${seg.name}`} />;
  });
}
